export const DialogKey = 'bulkPaymentFeesDialog';
